import * as HttpUtils from 'utils/HttpUtils'
import * as ListUtils from 'utils/ListUtils'
import FormConst from 'constants/FormConst'
import URLConst from 'constants/URLConst'
import { runInAction } from "mobx"
import { makeAutoObservable } from "mobx"
import CommonConst from 'constants/CommonConst'

/*
 * Module - OrderStore.js
 *
 * Description : 이지로드 결제 관련 스터어 입니다. 
 *
 * 작성자 : Choi young ho. 
 * Created on Fri Jan 21 2022
 * Copyright (c) 2022 Renewhouse corp
 */
export default class OrderStore {

    constructor(root) {
        this.root = root;
        this.initState();
        makeAutoObservable(this)
    }

    initState = () => {
        this.userInfo = null;   
        this.lst = []; 
    }

    /**
     * 결제 목록 검색을 
     * 서버에 요청 합니다. 
     * @param {*} searchField 
     * @param {*} searchKeyword
     * @param {*} pageNo 
     * @param {*} pageAmount 
     * @param {*} regState 
     * @returns 
     */
    doSearch = async ({
        searchField,
        searchKeyword,
        pageNo,
        pageAmount,
        regState
     }) => {
        let param = {};
        param[FormConst.SEARCH_FIELD] = searchField;
        param[FormConst.SEARCH_KEYWORD] = searchKeyword;
        param[FormConst.jqGRID_JSON_PROTOCOL_CURRERNT_PAGE] = pageNo;
        param[FormConst.jqGRID_JSON_PROTOCOL_RECORD_AMOUNT] = pageAmount;
        
        if(regState)
            param[FormConst.REG_STATE] = CommonConst.PAY_REG_STATE_ACCEPT;
        
        let result = await HttpUtils.doPostFormData(
            URLConst.ADMIN_ORDER_SEARCH_JSON, 
            param
        );
        
        let lst = ListUtils.replaceOrMergeList(
            this.lst,
            result[FormConst.LIST_FIELD],
            pageNo, 
            pageAmount, 
            // searchKeywordList.length, 
            (searchField == "") ? 0 : 1,
            this.setDataInited, 
            this.setNoResult, 
            this.setLastPage,
        ); 
        runInAction(() => {
            this.lst = lst;
        });
        
        return result;
    }

    /**
     * 거래 취소를 
     * 서버에 요청 합니다. 
     */
    reqRefund = async (
        payInfoId
    ) => {
        let param = {};
        param[FormConst.PAY_INFO_ID] = payInfoId;
        
        let result = await HttpUtils.doPostFormData(
            URLConst.ADMIN_ORDER_REFUND_JSON, 
            param
        );

        console.log("Result", result);
        return result;
    }

    /**
     * 거래 데이터를 
     * 서버에 요청 합니다. 
     * @param {*} payInfoId 
     * @returns 
     */
    getPayInfo = async (
        payInfoId
    ) => {
        let param = {};
        param[FormConst.PAY_INFO_ID] = payInfoId;
        
        let result = await HttpUtils.doPostFormData(
            URLConst.ADMIN_ORDER_INFO_JSON, 
            param
        );

        console.log("Result", result);
        return result;
    }
}